//const serviceUrl = "https://klickexmoneycard.com/cardservices/api/"
// const serviceUrl = "http://localhost:8001/api/"

//Test Server 
// const serviceUrl = localStorage.getItem('pform')==='AU'?"https://oxygentestenv01.oxygen-global.com/services/api/" :"https://oxygentestenv01.oxygen-global.com/services/api/"
//Prod Server  NOTE Service URL replaced with in fetch() 


// prod server 
    const AdminserviceUrl = process.env.REACT_APP_ADMINSERVICE_URL
    // console.log("Admin url" , AdminserviceUrl)
//test server
// const AdminserviceUrl = "https://oxygentestenv01.oxygen-global.com/cardholderadmin/" 
// const AdminserviceUrl = "http://localhost:7000/" 

const masterService = 'https://knect.oxygen-global.com/master/'

// var services = {
//     login: serviceUrl + "public/token",
//     signup: serviceUrl + "public/signup/create",
//     profileimg: serviceUrl + "rest/profile/updatePicture",
//     Reissue_activate_card: serviceUrl + "public/activate/reissueCard",
//     getFrankieData: serviceUrl + "public/scan/frankieOne/by/",
//     capcha: serviceUrl + "public/captcha",
//     get_public_key: serviceUrl + "public/application/getkey/",
//     ViewFAQ: AdminserviceUrl + "faq/public/getAllQuestionAnswersByProgramName/",
//     verify_card: serviceUrl + "public/card/verify",
//     kycData: serviceUrl + "public/validate/kycdata",
//     UpdatePos: serviceUrl + "rest/card/updatePosPreference",
//     ViewTC: AdminserviceUrl + "terms/public/getAllTermsConditionsByProgramName/",
//     get_cardImage: AdminserviceUrl + "program/public/getCardDesignByProgramName",
//     UpdateContactLess: serviceUrl + "rest/card/updateContactlessPreference",
//     UpdateATM: serviceUrl + "rest/card/updateAtmPreference",
//     UpdateInternational: serviceUrl + "rest/card/updateInternationalPreference",
//     UpdateEcom: serviceUrl + "rest/card/updateEcomPreference",
//     store_card: serviceUrl + "public/card/storeCard",
//     activate_card: serviceUrl + "public/card/activate",
//     secret_ques: serviceUrl + "public/signup/getAllSecretQuestions",
//     get_cardPreferance: serviceUrl + "rest/card/fetchPreference",
//     get_balance: serviceUrl + "public/getBalance",
//     update_user_info: serviceUrl + "public/signup/SignUpWithSecurityInfo",
//     get_cards: serviceUrl + "rest/card/getCards",
//     find_member: serviceUrl + "rest/member/findMembers",
//     add_friend: serviceUrl + "rest/member/addFriend",
//     get_profile: serviceUrl + "rest/profile/read",
//     update_basic: serviceUrl + "rest/profile/updateBasicInfo",
//     update_contact: serviceUrl + "rest/profile/updateContactInfo",
//     update_mailing: serviceUrl + "rest/profile/updateMailingInfo",
// 	   update_profile: serviceUrl + "rest/profile/updateCardHolderInfo",
//     update_profile_personalInfo : serviceUrl + "rest/profile/updateEmailAndMobileNo",
//     update_mailinginfo: serviceUrl + "rest/profile/updateMailingInfo",
//     get_friend: serviceUrl + "rest/member/getFriends",
//     dlt_friend: serviceUrl + "rest/member/deleteFriend",
//     edit_friend: serviceUrl + "rest/member/editFriend",
//     change_password: serviceUrl + "rest/profile/changePassword",
//     share_fund: serviceUrl + "rest/card/shareFunds",
//     change_pin: serviceUrl + "rest/card/changePIN",
//     get_userid: serviceUrl + "public/card",
//     get_password: serviceUrl + "public/validateUserId",
//     forgot_password: serviceUrl + "public/forgotPassword",
//     block_card: serviceUrl + "rest/card/setCardStatus",
//     country: masterService + "countries/listall",
//     change_seq_que: serviceUrl + "rest/profile/updateSecretQA",
//     send_userid: serviceUrl + "public/getUserId",
//     get_transactionid: serviceUrl + "rest/card/transactionHistory",
//     get_alerts: serviceUrl + "rest/card/readAlerts",
//     deb_txnpost_alert: serviceUrl + "rest/card/debitTxnPostAlert",
//     cdt_txnpost_alert: serviceUrl + "rest/card/creditTxnPostAlert",
//     card_bal_alert: serviceUrl + "rest/card/cardBalanceAlert",
//     insuf_bal_alert: serviceUrl + "rest/card/NonSufficientFundsAlert",
//     other_alert: serviceUrl + "rest/card/updateCardAlert",
//     get_cardactivity: serviceUrl + "rest/card/getCardActivity",
//     get_FailedTransactions: serviceUrl + "rest/card/failedTransactions",
//     contact_us: serviceUrl + "public/contactus",
//     valid_user_id: serviceUrl + "public/signup/verifyUserName",
//     update_forceSecret: serviceUrl + "rest/profile/forceSecretQAUpdate",
//     card_detail_service: serviceUrl + "rest/card/detailsByCardReferenceId",
//     card_detail_by_cardno_service: serviceUrl + "rest/card/detailsByCardNumber",
//     update_card_status: serviceUrl + "rest/card/updateCardStatusByRefId",
//     update_emailid: serviceUrl + "rest/profile/updateEmailAddress",
//     userid_info: serviceUrl + "rest/card/detailsByUserId",
//     mobno_info: serviceUrl + "rest/card/detailsByMobileNumber",
//     send_api_link: serviceUrl + "public/sendMobileAppLink",
//     resetsq_card_verify: serviceUrl + "public/verifyCardNumber",
//     resetsq_expiry_verify: serviceUrl + "public/verifyExpiryDate",
//     resetsq_mobNum_verify: serviceUrl + "public/verifyMobileNumber",
//     resetsq_dob_verify: serviceUrl + "public/verifyDateOfBirth",
//     resetsq_qa: serviceUrl + "public/resetSecretQA",
//     update_cardholder_info: serviceUrl + "rest/profile/updateProfile",

//     getCardWidget:serviceUrl +"rest/card/fetchCardWidget",
//     getTokenList :serviceUrl +"rest/card/getTokens",
//     updateTokens :serviceUrl +"rest/card/updateTokensByToken",
//     updateTokensByKit :serviceUrl +"rest/card/updateTokensByKitNo",
//     ViewWalletTC: AdminserviceUrl + "terms/getTermsConditionsListByProgramId/",
//     ViewWalletFAQ: AdminserviceUrl + "faq/getWalletQuestionAnswersByProgramId/",

//     verifyDigitalCard: serviceUrl + "public/card/verifyCardProxyNumber",
//     verifyDigitalCardWithOtp: serviceUrl + "public/card/verifyCardProxyNumberWithOTP",
//     resendOTPForDigiCard: serviceUrl +  "public/card/resendOTPForDigiCard",
//     // Replacement of card can be used for request a new physical card?
//     replacementOfCard : serviceUrl +"rest/card/replaceCard/new",
//     requestPhysicalCard : serviceUrl +"rest/card/requestPhysicalCard",
//     setPinpostRegKYC: serviceUrl + "public/updateCardStatusPinAndCustomerDetailsAfterRegistration",
//     activateReIssueCard : serviceUrl + "activateReIssueCard",
//     productFAQ: AdminserviceUrl + "faq/getProductFAQSByApplicationId/",
//     DownloadPDF:serviceUrl +"rest/card/downloadPDFTransactionHistory",
//     FailedDownloadPDF:serviceUrl +"rest/card/exportFailedTransactionPdf",
// }

const services = {
    login: "G_RG1ZXzzm2-JA",
    signup:  "EHauCinI0gVfkw",
    profileimg:  "u-SmPGR2OUb_zA",
    Reissue_activate_card:  "3sAR1yp7mnQvQg",
    getFrankieData:  "XXvyIkt8gouISg/",
    capcha:  "E4y6fGwn5W_XXw",
    get_public_key:  "WizmeBK11nYWMw/",
    ViewFAQ: "lFdi5qzaJ9X6hQ/",
    //  ViewFAQ: "faq/public/getAllQuestionAnswersByProgramName/",
    verify_card:  "a9RUZBKwOx7Meg",
    verify_card_number:"yH3QNq9L_5RvJ7cXQW",
    kycData:  "2PLMu8-sd_Eu2w",
    otp_UpdatePos:"pY7dQw8Z_3HtB5DD",
    UpdatePos:  "wy89JHsN7zmwMA",
    ViewTC: "QeXfrJ2xEGA6Nw/",
    get_cardImage:"yEkwyACn1jxpBQ",
    otp_UpdateContactLess:"pR6dQw8Z_3HtB5DD",
    UpdateContactLess:  "_4Bg5NaVRmC5hA",
    otp_UpdateAtm:"pZ7dQw8Z_3HtB5DD",
    UpdateATM:  "N3ujABpXEDPanQ",
    otp_UpdateInternational:"pZ6dQw8Z_3HtB5DD",
    UpdateInternational:  "Js1DMC9EUqWjVg",
    otp_UpdateEcom:"pM6dQw8Z_3HtB5DD",
    UpdateEcom:  "AziaS_q_LGvsZg",
    store_card:  "9TTHdTX1Z43sHw",
    activate_card:  "Kn84LlOqgJ2Bkg",
    secret_ques:  "Jh5PkKUSJXJlSg",
    get_cardPreferance:  "qYW1aNECdMs_hQ",
    get_balance:  "xCYnQP1Y2GcnYQ",
    update_user_info:  "UahDZYocOio8Zg",
    get_cards:  "Fj7r_iZAhfIXGQ",
    find_member:  "UtzZxu65qhlG4w",
    add_friend:  "-rPwHHCf-ssSqQ",
    get_profile:  "bvdEHCEqHXKb-Q",
    update_basic:  "sOB3Cs2QgQyMVQ",
    update_contact:  "gYbBEvxbzebJBQ",
    update_mailing:  "WL4EYtwUqNZVFg",
	update_profile:  "N5DEa6GE4qpq2Q",
    update_profile_personalInfo :  "l7-aIG7fUfZlCQ",
    update_mailinginfo:  "WL4EYtwUqNZVFg",
    get_friend:  "rBDIV3AEoTtjTA",
    dlt_friend:  "CFhymMEI7A_tpg",
    edit_friend:  "XyoiC_VX_veV-g",
    otp_change_password:"pKoL8dPOw8Z_6GHB5DD",
    change_password:  "1q4WieFQeSlX4A",
    share_fund:  "DjLTgyB-qh9LCg",
    otp_change_pin:"pL6dQw8Z_3HtB5DD",
    change_pin:  "i9wvaoVt8E-xGg",
    otp_get_userId:"pR6dQw8Z_3HtC0NDD",
    get_userid:  "WkH2krVAGZzNMQ",
    get_password:  "B7xAkhbnhsF2Gw",
    otp_forgot_password:"pR6dQHJoZ_3HtB5DD",
    forgot_password:  "pljYLq_jIk6Pew",
    otp_block_card:"pL6dQw8Z_6GHB5DD",
    block_card:  "_UDT5z0puxL1sw",
    country: "GE6w689qN1T5-A",
    otp_change_seq_que:"pKPP80dPOw8Z_6GHB5DD",
    change_seq_que:  "1fKXW6PJTxg1cg",
    send_userid:  "7uBlxp0gTkSmVg",
    get_transactionid:  "hQgMFC2U43Fk_g",
    get_alerts:  "BVcWUZ6Z-PGYGA",
    deb_txnpost_alert:  "MW0uR9Ya1pDoWw",
    cdt_txnpost_alert:  "1DP61-h1erNMTQ",
    card_bal_alert:  "3mqJ55vu6qOi0w",
    insuf_bal_alert:  "M6hpsKfXdXOjTA",
    other_alert:  "IsW-7dmkYN7jVA",
    get_cardactivity:  "CVTO8QWNuTELCw",
    get_FailedTransactions:  "Q9TQ5JE8fvjRcw",
    contact_us:  "CAYwLxyBYkmGvQ",
    valid_user_id:  "KP5TS1fAbaC4Qg",
    update_forceSecret:  "xu_NYwt9iQ77qA",
    card_detail_service:  "GFy-0t7c625zUg",
    card_detail_by_cardno_service:  "mAPvujVvBMdOlQ",
    update_card_status:  "8_FW6uW-X8-Fog",
    update_emailid:  "tRy7-J74k-eXrw",
    userid_info:  "SNnx2TMHmYkLBg",
    mobno_info:  "e7SSRkBHMwG1gQ",
    send_api_link:  "6Pt7ay2Qft7XtA",
    resetsq_card_verify:  "PXaM3i4VF49txg",
    resetsq_expiry_verify:  "MfBS_am0jxzYiA",
    resetsq_mobNum_verify:  "hNm6kIGkrNroAQ",
    resetsq_dob_verify:  "gNQTadwBrJh0YQ",
    resetsq_qa:  "oPB4EwqXLaOKtg",
    otp_reset_qa:"pNo99Qw8Z_3HtB5DD",
    update_cardholder_info:  "8mifORzlxUcUxg",

    getCardWidget:"ZFw_Ca90DblUJQ",
    getTokenList :"8hlG8DQRgDt-ZQ",
    updateTokens :"nM0en-2I0uYjlw",
    updateTokensByKit :"K4sN2Mbv79Y65A",
    ViewWalletTC: "g2mm0KFFqFeacA/",
    ViewWalletFAQ: "MEqlLC9cPBcdGw",

    // verifyDigitalCard:  "public/card/verifyCardProxyNumber",
        verifyDigitalCard:  "aT9mXc4R_7GhQ2kL",
    // verifyDigitalCardWithOtp:  "public/card/verifyCardProxyNumberWithOTP",
        verifyDigitalCardWithOtp:  "pF6nZy8D_3RtV5sJ",

    // resendOTPForDigiCard:   "public/card/resendOTPForDigiCard",
        resendOTPForDigiCard:   "qW2bNf7H_9LmC4xP",

    // Replacement of card can be used for request a new physical card?
    // replacementOfCard : "rest/card/replaceCard/new",
     replacementOfCard : "dK5rYt1G_8XpM3zQ",
    // requestPhysicalCard : "rest/card/requestPhysicalCard",
        requestPhysicalCard : "vJ7cLq9S_2GhR6mT",

    setPinpostRegKYC:  "GGr288IxpVU2Hg",
    // activateReIssueCard :  "activateReIssueCard",
        activateReIssueCard :  "mR4pXy2D_5NkT8vF",

    productFAQ: "MfUL-wACMP-bcA",
    DownloadPDF:"OHWCJuuwJc3GyQ",
    FailedDownloadPDF:"q2tsYmN1EzbU3g",
    // TCProd : "terms/getProductTNCByAppId",
        TCProd : "sH8nQk3L_6RpV1cZ",

    // TCDigWallet : "terms/getWalletTNCByAppId/"
    TCDigWallet : "tC9mFj5R_7XyN2gK",

    
      // requestOtp:serviceUrl +"public/sendOTPByUserName",
    requestOtp:"sH8nQk3L_6RpMjUooi",
 
    // loginBasedOnOTPPassword :serviceUrl +"public/tokenWithOTP",
    loginBasedOnOTPPassword :"sH8nQk3L_6RpMjUoi98T",

    loginWithPassword:"pOI0pUPOw8Z_6GHB5DD",
    //   loginWithPassword:"public/generateOtpToLogin",

    // loginWithOTP:"public/tokenWithOTP",
    loginWithOTP:"sH8nQk3L_6RpMjUoi98T",

    // resendOTPForLogin:"public/resendOTPForLogin",

        resendOTPForLogin:"pOI0pKK07Jw8Z_6GHB5DD",
}



// const services = {
//     login: "public/token",
//     signup:  "public/signup/create",
//     profileimg:  "rest/profile/updatePicture",
//     Reissue_activate_card:  "public/activate/reissueCard",
//     getFrankieData:  "public/scan/frankieOne/by/",
//     capcha:  "public/captcha",
//     get_public_key:  "public/application/getkey/",
    
//     ViewFAQ: "faq/public/getAllQuestionAnswersByProgramName/",
//     verify_card:  "public/card/verify",
//     kycData:  "public/validate/kycdata",
//     UpdatePos:  "rest/card/updatePosPreference",
//     ViewTC: "terms/public/getAllTermsConditionsByProgramName/",
//     get_cardImage:"program/public/getCardDesignByProgramName",
//     UpdateContactLess:  "rest/card/updateContactlessPreference",
//     UpdateATM:  "rest/card/updateAtmPreference",
//     UpdateInternational:  "rest/card/updateInternationalPreference",
//     UpdateEcom:  "rest/card/updateEcomPreference",
//     store_card:  "public/card/storeCard",
//     activate_card:  "public/card/activate",
//     secret_ques:  "public/signup/getAllSecretQuestions",
//     get_cardPreferance:  "rest/card/fetchPreference",
//     get_balance:  "public/getBalance",
//     update_user_info:  "public/signup/SignUpWithSecurityInfo",
//     get_cards:  "rest/card/getCards",
//     find_member:  "rest/member/findMembers",
//     add_friend:  "rest/member/addFriend",
//     get_profile:  "rest/profile/read",
//     update_basic:  "rest/profile/updateBasicInfo",
//     update_contact:  "rest/profile/updateContactInfo",
//     update_mailing:  "rest/profile/updateMailingInfo",
// 	update_profile:  "rest/profile/updateCardHolderInfo",
//     update_profile_personalInfo :  "rest/profile/updateEmailAndMobileNo",
//     update_mailinginfo:  "rest/profile/updateMailingInfo",
//     get_friend:  "rest/member/getFriends",
//     dlt_friend:  "rest/member/deleteFriend",
//     edit_friend:  "rest/member/editFriend",
//     change_password:  "rest/profile/changePassword",
//     share_fund:  "rest/card/shareFunds",
//     change_pin:  "rest/card/changePIN",
//     get_userid:  "public/card",
//     get_password:  "public/validateUserId",
//     forgot_password:  "public/forgotPassword",
//     block_card:  "rest/card/setCardStatus",
//     country: masterService + "countries/listall",
//     change_seq_que:  "rest/profile/updateSecretQA",
//     send_userid:  "public/getUserId",
//     get_transactionid:  "rest/card/transactionHistory",
//     get_alerts:  "rest/card/readAlerts",
//     deb_txnpost_alert:  "rest/card/debitTxnPostAlert",
//     cdt_txnpost_alert:  "rest/card/creditTxnPostAlert",
//     card_bal_alert:  "rest/card/cardBalanceAlert",
//     insuf_bal_alert:  "rest/card/NonSufficientFundsAlert",
//     other_alert:  "rest/card/updateCardAlert",
//     get_cardactivity:  "rest/card/getCardActivity",
//     get_FailedTransactions:  "rest/card/failedTransactions",
//     contact_us:  "public/contactus",
//     valid_user_id:  "public/signup/verifyUserName",
//     update_forceSecret:  "rest/profile/forceSecretQAUpdate",
//     card_detail_service:  "rest/card/detailsByCardReferenceId",
//     card_detail_by_cardno_service:  "rest/card/detailsByCardNumber",
//     update_card_status:  "rest/card/updateCardStatusByRefId",
//     update_emailid:  "rest/profile/updateEmailAddress",
//     userid_info:  "rest/card/detailsByUserId",
//     mobno_info:  "rest/card/detailsByMobileNumber",
//     send_api_link:  "public/sendMobileAppLink",
//     resetsq_card_verify:  "public/verifyCardNumber",
//     resetsq_expiry_verify:  "public/verifyExpiryDate",
//     resetsq_mobNum_verify:  "public/verifyMobileNumber",
//     resetsq_dob_verify:  "public/verifyDateOfBirth",
//     resetsq_qa:  "public/resetSecretQA",
//     update_cardholder_info:  "rest/profile/updateProfile",

//     getCardWidget:"rest/card/fetchCardWidget",
//     getTokenList :"rest/card/getTokens",
//     updateTokens :"rest/card/updateTokensByToken",
//     updateTokensByKit :"rest/card/updateTokensByKitNo",
//     ViewWalletTC: "terms/getTermsConditionsListByProgramId/",
//     ViewWalletFAQ: "faq/getWalletQuestionAnswersByProgramId/",

//     verifyDigitalCard:  "public/card/verifyCardProxyNumber",
//     verifyDigitalCardWithOtp:  "public/card/verifyCardProxyNumberWithOTP",
//     resendOTPForDigiCard:   "public/card/resendOTPForDigiCard",
//     // Replacement of card can be used for request a new physical card?
//     replacementOfCard : "rest/card/replaceCard/new",
//     requestPhysicalCard : "rest/card/requestPhysicalCard",
//     setPinpostRegKYC:  "public/updateCardStatusPinAndCustomerDetailsAfterRegistration",
//     activateReIssueCard :  "activateReIssueCard",
//     productFAQ: "faq/getProductFAQSByApplicationId/",
//     DownloadPDF:"rest/card/downloadPDFTransactionHistory",
//     FailedDownloadPDF:"rest/card/exportFailedTransactionPdf",
//     TCProd : "terms/getProductTNCByAppId/",
//     TCDigWallet : "terms/getWalletTNCByAppId/",
//           requestOtp:"public/sendOTPByUserName",
// //     requestOtp:"sH8nQk3L_6RpMjUooi",
 
// loginBasedOnOTPPassword :"public/tokenWithOTP",
// otp_block_card:"rest/card/sendOTPToBlockUnBlockCard",
// otp_change_pin:"rest/card/sendOTPToChangePin"
// }


export default services;


// WEBPACK FOOTER //
// ./src/services/allservices.jsx